// const SidebarData = [
//   {
//     label: "Menu",
//     isMainMenu: true,
//   },
//   {
//     label: "Dashboard",
//     icon: "mdi mdi-home-variant-outline",
//     url: "/dashboard",
//     issubMenubadge: true,
//     bgcolor: "bg-primary",
//     badgeValue: "3",
//   },

// {
//     label: "Hotels",
//     icon: "mdi mdi-home-variant-outline",
//     // url: "/hotels",
//     issubMenubadge: false,
//     subItem: [
//       { sublabel: "Hotels", link: "/hotels" },
//       { sublabel: "Employees", link: "/users" },
//       // { sublabel: "Email Compose", link: "/#l" },
//     ],

// },
//     {
//         label: "Request",
//         icon: "mdi mdi-calendar-outline",
//         isHasArrow: true,
//         url: "/pendinghotels",
//     },

//   {
//     label: "Email",
//     icon: "mdi mdi-email-outline",
//     subItem: [
//       { sublabel: "Inbox", link: "/#" },
//       { sublabel: "Read Email", link: "/#" },
//       { sublabel: "Email Compose", link: "/#l" },
//     ],
//   },

//   {
//     label: "Multi Level",
//     icon: "ri-share-line",
//     subItem: [
//       { sublabel: "Level 1.1", link: "/#" },
//       {
//         sublabel: "Level 1.2",
//         link: "/#",
//         subMenu: [{ title: "Level 2.1" }, { title: "Level 2.2" }],
//       },
//     ],
//   },
// ];
// export default SidebarData;

const AdminSidebarData = [
  {
    label: "MENU",
    isMainMenu: true,
  },
  {
    label: "Dashboard",
    icon: "mdi mdi-home-variant-outline",
    url: "/dashboard",
    issubMenubadge: true,
    bgcolor: "bg-primary",
    badgeValue: "3",
  },

  {
    label: "Hotels",
    icon: "mdi mdi-home-variant-outline",
    // url: "/hotels",
    issubMenubadge: false,
    subItem: [
      { sublabel: "Hotels", link: "/hotels" },
      // { sublabel: "Employees", link: "/users" },
      // { sublabel: "guest Menu", link: "/Customer-menu" },
    ],
  },
  // {
  //   label: "Restaurant Menu",
  //   icon: "mdi mdi-menu",
  //   issubMenubadge: false,
  //   subItem: [{ sublabel: "Menu", link: "/hotelmenu" }],
  // },

  {
    label: "Request",
    icon: "mdi mdi-calendar-outline",
    isHasArrow: true,
    url: "/pendinghotels",
  },
  {
    label: "Sub-Admin",
    icon: "mdi mdi-account-plus-outline",
    isHasArrow: true,
    url: "/sub-admin",
  },
  {
    label: "Customer queries",
    icon: "mdi mdi-account-plus-outline",
    isHasArrow: true,
    url: "/contact-messages",
  },
];
const SubAdminSidebarData = [
  {
    label: "MENU",
    isMainMenu: true,
  },
  {
    label: "Dashboard",
    icon: "mdi mdi-home-variant-outline",
    url: "/dashboard",
    issubMenubadge: true,
    bgcolor: "bg-primary",
    badgeValue: "3",
  },

  {
    label: "Hotels",
    icon: "mdi mdi-home-variant-outline",
    // url: "/hotels",
    issubMenubadge: false,
    subItem: [
      { sublabel: "Hotels", link: "/hotels" },
      // { sublabel: "Employees", link: "/users" },
      // { sublabel: "guest Menu", link: "/Customer-menu" },
    ],
  },
  // {
  //   label: "Restaurant Menu",
  //   icon: "mdi mdi-menu",
  //   issubMenubadge: false,
  //   subItem: [{ sublabel: "Menu", link: "/hotelmenu" }],
  // },

  {
    label: "Request",
    icon: "mdi mdi-calendar-outline",
    isHasArrow: true,
    url: "/pendinghotels",
  },

];
const Hotel_Admin_SidebarData = [
  {
    label: "MENU",
    isMainMenu: true,
  },
  {
    label: "Dashboard",
    icon: "mdi mdi-home-variant-outline",
    url: "/dashboard",
    isHasArrow: true,
  },
  {
    label: "MANAGER",
    isMainMenu: true,
    isHasArrow: true,
  },
  {
    label: "Guests Details" ,
    icon: "mdi mdi-account-outline",
    url: "/guest",
    isHasArrow: true,
  },
  {
    label: "Check In",
    icon: "mdi mdi-calendar-check-outline",
    url: "/reservations",
    isHasArrow: true,
  },
  {
    label: "Restaurant",
    icon: "mdi mdi-food",
    url: "/customer-menu",
    isHasArrow: true,
  },
  {
    label: "Spa",
    icon: "mdi mdi-spa-outline",
    url: "/spa",
    isHasArrow: true,
  },
  {
    label: "Rooms",
    icon: "mdi mdi-bed-outline",
    url: "/rooms",    isHasArrow:true,
  },
  {
    label: "Employees",
    icon: "mdi mdi-account-multiple-outline",
    url: "/users",
    isHasArrow: true,
  },

  // {
  //   label: "Rooms",
  //   icon: "mdi mdi-bed-outline",
  //   url: "/rooms",
  //   isHasArrow: true,
  // },


  {
    label: "Hotel Insights",
    icon: "mdi mdi-chart-box",
    url: "/hotel-insights",
    isHasArrow: true,
  },
  // {
  //   label: "Menu",
  //   icon: "mdi mdi-silverware-fork-knife",
  //   url: "/hotelmenu",
  //   isHasArrow: true,
  // },
];

const ManagerSidebarData = [
  {
    label: "Menu",
    isMainMenu: true,
  },
  {
    label: "Dashboard",
    icon: "mdi mdi-home-variant-outline",
    url: "/dashboard",
  },
  {
    label: "Hotels",
    icon: "mdi mdi-home-variant-outline",
    // url: "/hotels",
    issubMenubadge: false,
    subItem: [
      { sublabel: "Reservations", link: "/reservations" },
      { sublabel: "Employees", link: "/users" },
      { sublabel: "Guest", link: "/guest" },
      { sublabel: "Rooms", link: "/rooms" },
      { sublabel: "Spa", link: "/spa" },
      { sublabel: "guest Menu", link: "/Customer-menu" },
      { sublabel: "Menu", link: "/hotelmenu" },
      // { sublabel: "Email Compose", link: "/#l" },
    ],
  },
];
const SpaSidebarData = [
  {
    label: "Menu",
    isMainMenu: true,
  },
  {
    label: "Dashboard",
    icon: "mdi mdi-home-variant-outline",
    url: "/dashboard",
    isHasArrow:true,
  },
  {
    label: "Spa",
    icon: "mdi mdi-home-variant-outline",
    url: "/spa",
    issubMenubadge: false,
    isHasArrow:true,
    // subItem: [
    //   { sublabel: "Reservations", link: "/reservations" },
    //   { sublabel: "Employees", link: "/users" },
    //   { sublabel: "Guest", link: "/guest" },
    //   { sublabel: "Rooms", link: "/rooms" },
    //   { sublabel: "Spa", link: "/spa" },
    //   { sublabel: "guest Menu", link: "/Customer-menu" },
    //   { sublabel: "Menu", link: "/hotelmenu" },
    //   // { sublabel: "Email Compose", link: "/#l" },
    // ],
  },
  {
    label: "Guest",
    icon: "mdi mdi-account-outline",
    url: "/guest",
    isHasArrow: true,
  },
];

const ReceponistSidebarData = [
  {
    label: "Menu",
    isMainMenu: true,    isHasArrow:true,
  },
  {
    label: "Dashboard",
    icon: "mdi mdi-home-variant-outline",
    url: "/dashboard",    isHasArrow:true,
  },
  {
    label: "Reservations",
    icon: "mdi mdi-calendar-check-outline",
    url: "/reservations",    isHasArrow:true,
  },
  {
    label: "Rooms",
    icon: "mdi mdi-bed-outline",
    url: "/rooms",    isHasArrow:true,
  },
  {
    label: "Guest",
    icon: "mdi mdi-account-outline",
    url: "/guest",    isHasArrow:true,
  },

];
const restoSidebarData = [
  {
    label: "Menu",
    isMainMenu: true,    isHasArrow:true,
  },
  {
    label: "Dashboard",
    icon: "mdi mdi-home-variant-outline",
    url: "/dashboard",    isHasArrow:true,
  },
  {
    label: " Menu",
    icon: "mdi mdi-calendar-check-outline",
    url: "/Customer-menu",    isHasArrow:true,
  },
  {
    label: "Hotel Guest",
    icon: "mdi mdi-account-outline",
    url: "/guest",
    isHasArrow: true,
  },
  // {
  //   label: "Rooms",
  //   icon: "mdi mdi-bed-outline",
  //   url: "/rooms",    isHasArrow:true,
  // },
  // {
  //   label: "Guest",
  //   icon: "mdi mdi-account-outline",
  //   url: "/guest",    isHasArrow:true,
  // },

];

export {
  AdminSidebarData,
  Hotel_Admin_SidebarData,
  ManagerSidebarData,
  ReceponistSidebarData,SpaSidebarData,restoSidebarData,SubAdminSidebarData
};
